module.exports = __webpack_public_path__ + "img/christmas_en.aa2a210c.png";